import { TOGGLE_SERVICE_VIEW, TOGGLE_SERVICE_FORM } from 'constants/ActionTypes';

// Handles service view modal
export const toggleServiceView = (serviceId = null) => {
  return {
    type: TOGGLE_SERVICE_VIEW,
    serviceId,
  };
};

// Handles service form modal
export const toggleServiceForm = (serviceId = null, callback) => {
  return {
    type: TOGGLE_SERVICE_FORM,
    serviceId,
    callback,
  };
};
